import React, { useRef } from "react";
import Gallery from "react-image-gallery";
import "react-image-gallery/styles/image-gallery.css";
import "../Styles/Components/UrunCarousel.css";

const ImageCarousel = ({ images }) => {
  const galleryRef = useRef(null);

  const galleryImages = images.map((img) => ({
    original: img,
    thumbnail: img,
    originalAlt: 'Araç Görseli',
    thumbnailAlt: 'Araç Küçük Görsel'
  }));

  const handleImageClick = () => {
    if (galleryRef.current) {
      galleryRef.current.fullScreen();
    }
  };

  return (
    <div className="carousel-container">
      <Gallery
        ref={galleryRef}
        items={galleryImages}
        showPlayButton={false}
        autoPlay={false}
        showFullscreenButton={true}
        showThumbnails={true}
        showFullscreenThumbnails={true}
        thumbnailPosition="bottom"
        useBrowserFullscreen={true} 
        slideDuration={450}
        showIndex={false}
        onClick={handleImageClick}
        
      />
    </div>
  );
};

export default ImageCarousel;